// extracted by mini-css-extract-plugin
export default {"whatsApp":"_3czar","whatsappDesktop":"_1HUs_","whatsappIcon":"_2wKNw","whatsappWithText":"_2xSoZ","whatsappButtonText":"_6pLa3"};